import { LAB_REPORT } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";

import toast from "react-hot-toast";

type ICartAPIResponse = { status: boolean; message: string };

export const useUploadLabReportAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (
      requisition_id: string,
      paramsBody: File[],
      method: "post" | "put" = "post",
      removed_report_indices: number[] = [],
    ) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const formData = new FormData();
        paramsBody.forEach((file) => {
          formData.append("lab_report_file", file);
        });
        if (method === "put" && removed_report_indices.length > 0) {
          formData.append("removed_report_indices", JSON.stringify(removed_report_indices));
        }

        const response: ICartAPIResponse = await axios[method](
          `${LAB_REPORT.UPLOAD_LAB_REPORT.baseURL}?requisition_id=${requisition_id}`,
          formData,
          {
            headers: {
              Authorization: `${accessToken}`,
            },
          },
        )
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              toast.success(res.data.message);
              return { status: true, message: res.data.message };
            }
            return { status: false, message: res.data.message };
          })
          .catch((e: AxiosError) => {
            if (e.config) {
              sendCurl(e.config["curlCommand"]);
            }
            captureError(e);
            return { status: false, message: "" };
          });

        return response;
      } catch (e: any) {
        captureError(e);
      }
    },
    [dispatch],
  );

  return { execute };
};
